<template>
  <div v-if="events.length > 0">
    <div class="swiper">
      <div class="swiper-wrapper">
        <div
          v-for="event in events"
          :key="event.id"
          class="swiper-slide"
        >
          <div class="event_archive__img-box">
            <div class="event_archive__img-box__avatar">
              <img
                :src="event.user_avatar"
                class="p-avatar--vsm p-avatar--circle"
              >
            </div>

            <a :href="event.link">
              <div class="event_archive__img-box__img">
                <img
                  :src="event.main_image"
                  class="event_archive__img-box__img-fill"
                >
              </div>
              <div class="event_archive__img-box__info">
                <div class="event_archive__img-box__info__detail">
                  <div class="event_archive__img-box__info__detail__schedule">
                    <div class="p-txt-tiny p-txt-light">{{ event.event_date }}</div>
                  </div>
                  <div class="event_archive__img-box__info__detail__category">
                    <div
                      class="event_tag"
                      :class="event.organization_category"
                    >{{ event.organization_category_text }}</div>
                  </div>
                </div>
                <div class="event_archive__img-box__info__title">
                  <h3
                    class="p-txt-vsmall p-txt-bold event_archive__img-box__info__title--clamp"
                  >
                    {{ event.title }}
                  </h3>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="swiper-pagination" />
      <div class="swiper-button-prev" />
      <div class="swiper-button-next" />
    </div>
  </div>
</template>

<script>
import { Swiper, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'

Swiper.use([Navigation, Pagination])

export default {
  name: 'SwiperCarousel',
  props: {
    events: {
      type: Array,
      required: true
    }
  },
  mounted () {
    if (this.events.length > 0) {
      this.initializeSwiper()
    }
  },
  methods: {
    initializeSwiper () {
      const swiperEl = this.$el.querySelector('.swiper')

      new Swiper(swiperEl, {
        slidesPerView: 1.3,
        slidesPerGroup: 1,
        spaceBetween: 8,
        loop: false,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          768: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 40
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.swiper {
  width: 100%;
  margin: 20px 0;
  // スマホサイズで崩れるのを防ぐ対応
  // https://github.com/nolimits4web/swiper/issues/3599#issue-626061672
  // https://github.com/nolimits4web/swiper/issues/3599#issuecomment-1696670314
  display: grid;

  .swiper-wrapper {
    min-width: 0;
  }
  .swiper-slide {
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: white;
  }
}

.swiper-button-prev,
.swiper-button-next {
  top: 0;
  width: calc(var(--swiper-navigation-size) / 44 * 40);
  height: 100%;
  margin-top: 0;
  background-color: rgba(255, 255, 255, 0.5);
  color: #333;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 0;
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 0;
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 1.8rem;
}
</style>
